/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://7eyzlhasirc3hpbse7k54d6cxi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-a6llklq6tfa65g7b77gw63q7mu",
    "aws_cognito_identity_pool_id": "us-east-1:bccdb037-76e3-466a-91c0-4ad2113ff9d5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ZEakws72W",
    "aws_user_pools_web_client_id": "6tijrmjk9nm5bnjjbk394hn5u8",
    "oauth": {
        "domain": "phomo-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "phomo://",
        "redirectSignOut": "phomo://",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "phomo60be8-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
